import React, { useState, useEffect } from 'react';
import { Grid, Typography, Card, CardContent, CardActionArea } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import { useConfluence } from "../components/qeeConfluenceProvider"; 

import AccountBoxIcon from '@material-ui/icons/AccountBox';
import HelpOutlinedIcon from '@mui/icons-material/HelpOutlined';
import PrivacyTipIcon from '@mui/icons-material/PrivacyTip';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import ChatIcon from '@mui/icons-material/Chat';
import ChecklistIcon from '@mui/icons-material/Checklist';
import LocalActivityIcon from '@material-ui/icons/LocalActivity';
import MapsHomeIcon from '@material-ui/icons/Home';
import HomeWorkIcon from '@material-ui/icons/HomeWork';
import SecurityIcon from '@material-ui/icons/Security';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import ResponsiveAppBar from '../components/appbar';
import QeeNavigator from '../context/navigator';
import { usrIsAdmin } from "../util/helpers";

import { useAuth } from "../context/provider";	
import { authMiddleWare, setLocalStorageAuthToken } from '../util/auth';

import { resetVersion } from "../api/service";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    appBarWrapper: {
        width: '100%',
        position: 'relative',
        left: -7,
        top: -7,		
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        width: '100%',
    },
    gridContainerWrapper: {
        width: '95%',
        maxWidth: 1000,
        margin: '0 auto',
        padding: theme.spacing(2),
        textAlign: 'center',
        [theme.breakpoints.down('xs')]: {		
			maxWidth: '80%',
        },			
    },
    gridContainer: {
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
        },
    },
    card: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: theme.spacing(2),
        transition: 'transform 0.2s ease-in-out',
        '&:hover': {
            transform: 'scale(1.05)',
        },
        minHeight: 200, // Ensures consistent height across rows
    },
    iconContainer: {
        minHeight: 70,  // Adjusted to allow more space for bigger icons
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    icon: {
        fontSize: 80,  // Increased font size for the icons
		color: theme.palette.primary.main
    },
    label: {
        marginTop: theme.spacing(1),
        fontWeight: 'bold',
        textAlign: 'center',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        width: '100%',
    },
    sublabel: {
        color: theme.palette.text.secondary,
        fontSize: '0.875rem',
        textAlign: 'center',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        //whiteSpace: 'nowrap',
        width: '100%',
    },
    cardContent: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
    }
}));

const Dashboard = (props) => {
    const { setOpenConfluenceDialog } = useConfluence();
    const { setOpenQeeDialog, gstate } = useAuth();    
	
    const classes = useStyles();
    const navigate = useNavigate();
    const location = useLocation();	
	
	const { loadHome, loadOrds, loadOrdsInsurance, loadChats, loadSacs, loadAccount, loadAdmin } = QeeNavigator();	
	
    const [state, setState] = useState({
        uiLoading: true,
    });	

	const showConfluenceHome = () => {
        setOpenConfluenceDialog();
    };

    const showVersionInfo = () => {
        setOpenQeeDialog({ open: true, id: 'dlgVersionInfo' });
    };

    const logoutHandler = () => {
        localStorage.removeItem('AuthToken');
        navigate('/login');
    };
	
	
	// re-login the user (aen-20240912)
	useEffect(() => {		
		
		if (props.location) {
			const urlParams = new URLSearchParams(props.location.search);
			const authToken = decodeURIComponent(urlParams.get('access_token'));
			const refreshToken = decodeURIComponent(urlParams.get('refresh_token'));
			
			if (authToken && authToken !== 'null' && authToken !== '') {
				localStorage.setItem('AuthToken', 'Bearer ' + authToken);
				localStorage.setItem('method', 'AuthToken set from url');
			}
			if (refreshToken && refreshToken !== 'null' && refreshToken !== '') {
				localStorage.setItem('RefreshToken', refreshToken);
				localStorage.setItem('method', 'RefreshToken set from url');
			}
		}

		resetVersion();
		
		const authToken = localStorage.getItem('AuthToken');
		if (authToken == null) navigate('/login');		
		const refreshToken = localStorage.getItem('RefreshToken');
		axios.defaults.headers.common = { Authorization: `${authToken}`, RefreshToken: refreshToken };				
		console.log('GET /api/usr');
		axios.get('/api/usr')
			.then((response) => {
				console.log('response', response);	
				let usr = {
					admin: response.data.userCredentials.admin,					
					per_firstname: response.data.userCredentials.per_firstname,
					per_lastname: response.data.userCredentials.per_lastname,
					cch_email_o: response.data.userCredentials.cch_email_o,
					cch_phone_o: response.data.userCredentials.cch_phone_o,
					addr_country_o: response.data.userCredentials.addr_country_o,
					username: response.data.userCredentials.username,
					id: response.data.userCredentials.id,															
					usrId: response.data.userCredentials.userId,							
					per_org_id: response.data.userCredentials.per_org_id,					
					profilePicture: response.data.userCredentials.imageUrl,					
					usr_unread_chat_msgs_count: response.data.userCredentials.usr_unread_chat_msgs_count,					
					usr_prm_block: response.data.userCredentials.usr_prm_block,										
					lic: JSON.parse(JSON.stringify(response.data.userCredentials.lic)),	
					synapcusConfig: response.data.synapcusConfig ? JSON.parse(JSON.stringify(response.data.synapcusConfig)) : {},
					uiLoading: false
				}; 	
				setLocalStorageAuthToken(response);
				//setState(usr);
				//setUsr(usr);
				//setUnreadMessagesCount( usr.usr_unread_chat_msgs_count);
				sessionStorage.setItem('usr', JSON.stringify(usr));				
								
			})
			.catch((error) => {
				console.log('GET /api/usr ERR', error);
				if (error.response.status === 403) {
					navigate('/login');
				}
				//setState({ errorMsg: 'Error in retrieving the data' });
			});
    }, []);	

	const settings = [
        { nm: 'Mein Konto', fct: loadAccount, ico: <AccountBoxIcon /> },
		{ nm: 'Nachrichten', fct:loadChats, ico:<ChatIcon />},				
		{ nm: 'Aktivitäten', fct:loadSacs, ico:<ChecklistIcon />},	
		{ nm: 'Administration', fct:loadAdmin, ico:<AdminPanelSettingsIcon />},		
        { nm: 'Wissensassistent', fct: showConfluenceHome, ico: <HelpOutlinedIcon /> },
        { nm: 'Versionsinfo', fct: showVersionInfo, ico: <PrivacyTipIcon /> },
        { nm: 'Logout', fct: logoutHandler, ico: <ExitToAppIcon /> }
    ];
	if (!usrIsAdmin()) {
		const adminIndex = settings.findIndex((item) => item.nm === 'Administration');
		if (adminIndex !== -1) {
			settings.splice(adminIndex, 1);
		}
	}	

   const switchSubpage = () => {
        switch (gstate.currSubpage) {
            default: return <></>;
        }
    };

    const subapps = [
        {
			label: 'Aktivitäten',
			sublabel: 'Meine gesendeten oder mir zugewiesenen Aktivitäten und Chats',
			icon: <LocalActivityIcon className={classes.icon} />,
			action: loadSacs,
		},
		{
			label: 'Immobilien',
			sublabel: 'Portfolio, Kaufoptionen, energetische Berechnungen, Dienstleister',
			icon: <HomeWorkIcon className={classes.icon} />,
			action: loadHome,
		},
		{
			label: 'Versicherungen',
			sublabel: 'Meine Versicherungen im Überblick, neue Verträge abschließen',
			icon: <SecurityIcon className={classes.icon} />,
			action: loadOrdsInsurance,
		},
		{
			label: 'Meine Daten',
			sublabel: 'Mein Propertec-Konto und meine persönlichen Daten',
			icon: <AccountCircleIcon className={classes.icon} />,
			action: loadAccount,
		},
        // Add more items as needed
    ];

    return (
        <div className={classes.root}>
            <div className={classes.appBarWrapper}>
                <ResponsiveAppBar 
                    hideDrawer={true}
                    className={classes.appBar} 
                    switchSubpage={switchSubpage}
                    pages={[]}
                    settings={settings}					
                />
            </div>		
            <Typography variant="h1" gutterBottom>
                Mein Dashboard
            </Typography>
            <div className={classes.gridContainerWrapper}>
                <Grid container spacing={3} className={classes.gridContainer}>
                    {subapps.map((app, index) => (
                        <Grid item xs={12} sm={6} md={4} key={index}>
                            <Card className={classes.card}>
                                <CardActionArea onClick={app.action} className={classes.cardContent}>
                                    <CardContent>
                                        <div className={classes.iconContainer}>
                                            {app.icon}
                                        </div>
                                        <Typography className={classes.label} variant="h6">
                                            {app.label}
                                        </Typography>
                                        <Typography className={classes.sublabel} variant="body2">
                                            {app.sublabel}
                                        </Typography>
                                    </CardContent>
                                </CardActionArea>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </div>
        </div>
    );
};

export default Dashboard;
